import React, { useState, useEffect } from "react";
import useAuth from "../hooks/useAuth";
import useMatricula from "../hooks/useMatricula";
import { obtenerLabelEtiqueta } from "../utils/idioma/LabelsIdioma";
import RowAsignatura from "./RowAsignatura";
import { apiAsignatura, apiAsignaturaFranja, apiGrupos, apiGruposFranja } from "../config/constantes";
import useProcesoMatricula from "../hooks/useProcesoMatricula";

const Asignaturas = () => {
  let { listadoAsignaturas, setListadoAsignaturas, listadoFranjas, mostrarAsignaturas,
    franjaSeleccionadaAsignaturas, setFranjaSeleccionadaAsignaturas,
    obtenerDatosEstudiante, setMostrarAsignaturas, setGruposHabilitados,
    alertaMensaje, setAlertaMensaje, setDisableListadoFranjas, disableListadoFranjas, multifranjas, mostrarAlerta, setMostrarAlerta,
    setCargandoGrupos
  } = useMatricula();

  let { setLoading } = useProcesoMatricula();

  const { cinstitucion, cprograma, cperiodo, cpersona, franja } =
    obtenerDatosEstudiante || {};


  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));

  let [listadoAsignaturasFiltrar, setListadoAsignaturasFiltrar] = useState([]);

  let [limitAsignatura, setLimitAsignatura] = useState({});

  let [busquedaAsignatura, setBusquedaAsignatura] = useState("");

  let [disableVerGrupos, setDisableVerGrupos] = useState(false);
  let [mostrarListadoAsignatura, setMostrarListadoAsignatura] = useState(true);
  let [creditosTotales, seCreditosTotales] = useState(null);
  let [gruposCargadosPara, setGruposCargadosPara] = useState(null);


  const { listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});

  useEffect(() => {
    setListadoAsignaturasFiltrar(listadoAsignaturas);
    let traerUnaAsignaturaParaLimite = () => {
      listadoAsignaturas.map((data, index) => {
        if (index == 0) {
          setLimitAsignatura(data);
        }
      });
    };
    traerUnaAsignaturaParaLimite();
  }, [listadoAsignaturas]);

  let getDataMultifranjas = async () => {
    let asignaturas = await getAsignaturas()

    setMostrarAsignaturas(asignaturas?.length > 0)
    setMostrarAlerta(asignaturas?.length == 0)

    setDisableVerGrupos(!(asignaturas?.length > 0))
  }

  useEffect(() => {
    if (multifranjas) {
      if (franjaSeleccionadaAsignaturas != null && franjaSeleccionadaAsignaturas != '' && franjaSeleccionadaAsignaturas != undefined) {
        if (Object.keys(obtenerDatosEstudiante).length > 0) {
          getDataMultifranjas()
        }
      } else {
        setMostrarAlerta(true)
        setAlertaMensaje('Seleccione una franja para visualizar la oferta disponible.')
        setMostrarAsignaturas(false)
      }
    }
  }, [franjaSeleccionadaAsignaturas, obtenerDatosEstudiante]);

  useEffect(() => {
    if (multifranjas) {
      if (listadoFranjas.length >= 1) {
      } else {
        setMostrarAsignaturas(false)
        setDisableListadoFranjas(true)
        setMostrarAlerta(true)
        setAlertaMensaje('El alumno no tiene franjas asignadas en el catálogo.')
      }
    }
  }, [listadoFranjas]);


  useEffect(() => {
    if ((multifranjas == false) && Object.keys(obtenerDatosEstudiante).length > 0) {

      if (franja == '' || franja == null || franja == undefined) {
        setAlertaMensaje('No tiene franja asignada, comuníquese con la OAMRA.')
        setMostrarAlerta(true)
      } else {
        getDataMultifranjas()
        setMostrarAsignaturas(true)
        setMostrarAlerta(false)
      }
    }
  }, [multifranjas, obtenerDatosEstudiante])


  let handleBuscar = (busquedaChange = "", tipo = 1) => {
    let valorFiltrar = tipo == 1 ? busquedaAsignatura : busquedaChange;
    let dataFilter = listadoAsignaturas.filter((info) => {
      return (
        info.dcurso
          .toLowerCase()
          .indexOf(String(valorFiltrar).toLowerCase()) !== -1
      );
    });
    setListadoAsignaturasFiltrar(dataFilter);
  };

  const prometeValidarApi = (api, config) => {
    return new Promise((resolver, rechazar) => {
      fetch(api, config).then((data) => {
        if (data.status == 200) {
          resolver(data);
        } else {
          rechazar(new Error(data));
        }
      });
    });
  };

  const handleSeleccionarFranja = async (value) => {
    setFranjaSeleccionadaAsignaturas(value)
  }

  const handleVerGrupos = async () => {
    const claveFranja = multifranjas ? franjaSeleccionadaAsignaturas : "default";
    if (gruposCargadosPara !== claveFranja) {
      await getGruposHabilitados();
      setGruposCargadosPara(claveFranja);
    }
  }

  const getAsignaturas = async () => {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cinstitucion: Number(cinstitucion),
        p_cprograma: Number(cprograma),
        p_cperiodo: Number(cperiodo),
        p_cpersona: Number(cpersona),
      }),
    };

    const configFranjas = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cinstitucion: Number(cinstitucion),
        p_cprograma: Number(cprograma),
        p_cperiodo: Number(cperiodo),
        p_cpersona: Number(cpersona),
        p_franja: franjaSeleccionadaAsignaturas,
      }),
    };
    try {
      setLoading(true);
      setListadoAsignaturas([])
      let listaCursos = [];
      if (multifranjas) {
        listaCursos = await prometeValidarApi(`${apiAsignaturaFranja}`, configFranjas);
      } else {
        listaCursos = await prometeValidarApi(`${apiAsignatura}`, config);
      }


      const listaCursosJSON = await listaCursos.json();
      const { Data } = listaCursosJSON;
      setMostrarListadoAsignatura(Data?.length != 0)

      let sumCreditos = Data.reduce((sum, item) => sum + item.ncredito, 0);

      seCreditosTotales(sumCreditos)

      if (Data?.length == 0) {

        if (multifranjas) {
          setMostrarAlerta(true)
          if (franja == '' || franja == null) {
            setAlertaMensaje('No hay asignaturas para mostrar.')
          } else {
            setAlertaMensaje('No hay asignaturas para mostrar.')
          }
        } else {
          if (franja != '' && franja != null && franja != undefined) {
            setAlertaMensaje('No tiene oferta para la franja asignada, comuníquese con la OAMRA.')
          }
          setMostrarAlerta(true)
        }
      }

      setListadoAsignaturas(Data);

      return Data;
     
    } catch (error) {
      setLoading(false);
      throw error;
    } finally {
      setLoading(false);
    }
  }

  let getGruposHabilitados = async () => {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cinstitucion: Number(cinstitucion),
        p_cprograma: Number(cprograma),
        p_cperiodo: Number(cperiodo),
        p_cpersona: Number(cpersona),
      }),
    };

    const configFranjas = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cinstitucion: Number(cinstitucion),
        p_cprograma: Number(cprograma),
        p_cperiodo: Number(cperiodo),
        p_cpersona: Number(cpersona),
        p_franja: franjaSeleccionadaAsignaturas
      }),
    };
    try {
      setLoading(true);
      setCargandoGrupos(true);
      let listaCursos = [];

      if (multifranjas) {
        listaCursos = await prometeValidarApi(`${apiGruposFranja}`, configFranjas);
      } else {
        listaCursos = await prometeValidarApi(`${apiGrupos}`, config);
      }

      const listaCursosJson = await listaCursos.json();
      const { Data } = listaCursosJson;

      setDisableVerGrupos(Data?.length == 0)

      if (Data?.length == 0) {
        setAlertaMensaje('No hay grupos habilitados para la franja seleccionada.')
        setMostrarAlerta(true)
        setCargandoGrupos(false);
      } else {
        setAlertaMensaje('')
        setMostrarAlerta(false)
      }

      let listOrdenadaEquivalente = Data.sort(function (a, b) {
        if (a.dcurso < b.dcurso) {
          return -1;
        }
        if (a.dcurso > b.dcurso) {
          return 1;
        }

        if (a.dequivalente < b.dequivalente) {
          return -1;
        }
        if (a.dequivalente > b.dequivalente) {
          return 1;
        }
        return 0;
      });
      setGruposHabilitados(listOrdenadaEquivalente);

    } catch (error) {
      setLoading(false);
      setCargandoGrupos(false);
      throw error;
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        asignaturas_habilitadas: obtenerLabelEtiqueta(
          "lbl_home_asignaturas_habilitadas",
          listadoEtiquetas
        ),
        global_programa: obtenerLabelEtiqueta(
          "lbl_global_programa",
          listadoEtiquetas
        ),
        limite_asignaturas: obtenerLabelEtiqueta(
          "lbl_home_limite_asignaturas",
          listadoEtiquetas
        ),
        limite_creditos: obtenerLabelEtiqueta(
          "lbl_home_limite_creditos",
          listadoEtiquetas
        ),
        msj_ver_grupos: obtenerLabelEtiqueta(
          "lbl_home_msj_ver_grupos",
          listadoEtiquetas
        ),
        msj_buscar_asignatura: obtenerLabelEtiqueta(
          "lbl_global_msj_buscar_asignatura",
          listadoEtiquetas
        ),
      });
    }
  }, [listadoEtiquetas]);

  const calculoDeAignaturas = (type) => {
    let resultado;

    if (type === "totalAsignatura") {
      resultado = listadoAsignaturas.length;
    }
    if (type === "O") {
      resultado = listadoAsignaturas.filter(e => e.stipo === 'O').length;
    }
    if (type === "E") {
      resultado = listadoAsignaturas.filter(e => e.stipo === 'E').length;
    }
    if (type === "C") {
      resultado = listadoAsignaturas.filter(e => e.stipo === 'C').length;
    }
    return resultado;
  }

  const {
    asignaturas_habilitadas,
    limite_asignaturas,
    limite_creditos,
    msj_ver_grupos,
    msj_buscar_asignatura,
  } = etiquetas;


  return (
    <div className="card shadow-sm mt-4 mb-5">
      <div className="card-body">
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active"
              id="home-tab"
              data-bs-toggle="tab"
              data-bs-target="#home"
              type="button"
              role="tab"
              aria-controls="home"
              aria-selected="true"
            >
              <i className="fal fa-book  text-secondary me-2"></i>
              {asignaturas_habilitadas}
            </button>
          </li>
        </ul>
        <div className="tab-content" id="myTabContent">
          <div
            className="tab-pane fade show active"
            id="home"
            role="tabpanel"
            aria-labelledby="home-tab"
          >
            <div className="row">
              <div className="my-4 d-flex justify-content-between align-items-end gap-3">
                {
                  multifranjas && <div className="form-group w-50">
                    <label className="fw-medium mb-2">Seleccionar franja:</label>
                    <select
                      className="form-select form-select-sm"
                      aria-label="Default select example"
                      onChange={(e) => {
                        handleSeleccionarFranja(e.target.value);
                      }}
                      value={franjaSeleccionadaAsignaturas}
                      disabled={disableListadoFranjas}
                    >
                      <option value="" selected>Seleccione una opción</option>

                      {listadoFranjas?.map((item) => {
                        return (
                          <option key={item?.sfranja} value={item?.sfranja}>
                            {item?.dfranja}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                }

                <div className="input-group flex-nowrap">
                  <input
                    autoComplete="off"
                    type="text"
                    className="search-input form-control form-control-sm"
                    id="exampleFormControlInput1"
                    placeholder={msj_buscar_asignatura}
                    onChange={(e) => {
                      setBusquedaAsignatura(e.target.value);
                      handleBuscar(e.target.value, 2);
                    }}
                  />
                  <span
                    className="input-group-text login-control bg-white"
                    id="addon-wrapping"
                    style={{ cursor: "pointer" }}
                    onClick={handleBuscar}
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.5 0C8.22391 0 9.87721 0.684819 11.0962 1.90381C12.3152 3.12279 13 4.77609 13 6.5C13 8.11 12.41 9.59 11.44 10.73L11.71 11H12.5L17.5 16L16 17.5L11 12.5V11.71L10.73 11.44C9.59 12.41 8.11 13 6.5 13C4.77609 13 3.12279 12.3152 1.90381 11.0962C0.684819 9.87721 0 8.22391 0 6.5C0 4.77609 0.684819 3.12279 1.90381 1.90381C3.12279 0.684819 4.77609 0 6.5 0ZM6.5 2C4 2 2 4 2 6.5C2 9 4 11 6.5 11C9 11 11 9 11 6.5C11 4 9 2 6.5 2Z"
                        fill="#B80A28"
                      />
                    </svg>
                  </span>
                </div>
              </div>

              {
                mostrarAsignaturas && <>
                  <div className="d-flex justify-content-between va-middle course-info-1 mb-1">
                    <p className=" fw-medium  mb-0 title-program">
                      {limitAsignatura.dprograma}
                    </p>
                  </div>

                  <div className="d-flex justify-content-between va-middle course-info-1 mb-4">
                    {/* <p className="mb-0">
                      {limite_asignaturas}:{" "}
                      <span className="fw-medium">
                        {limitAsignatura.nlimitecursos}
                      </span>
                    </p> */}

                    <p className=" mb-0">
                      {limite_creditos}:{" "}
                      <span className="fw-medium">
                        {limitAsignatura.nlimitecreditos}
                      </span>
                    </p>

                    <button
                      className="btn btn-sm btn-outline-secondary w-25"
                      data-bs-toggle="modal"
                      data-bs-target="#grupos"
                      disabled={disableVerGrupos}
                      onClick={handleVerGrupos}
                    >
                      <svg
                        width="20"
                        height="19"
                        viewBox="0 0 20 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.99992 7.125C10.663 7.125 11.2988 7.37522 11.7677 7.82062C12.2365 8.26602 12.4999 8.87011 12.4999 9.5C12.4999 10.1299 12.2365 10.734 11.7677 11.1794C11.2988 11.6248 10.663 11.875 9.99992 11.875C9.33688 11.875 8.70099 11.6248 8.23215 11.1794C7.76331 10.734 7.49992 10.1299 7.49992 9.5C7.49992 8.87011 7.76331 8.26602 8.23215 7.82062C8.70099 7.37522 9.33688 7.125 9.99992 7.125M9.99992 3.5625C14.1666 3.5625 17.7249 6.02458 19.1666 9.5C17.7249 12.9754 14.1666 15.4375 9.99992 15.4375C5.83325 15.4375 2.27492 12.9754 0.833252 9.5C2.27492 6.02458 5.83325 3.5625 9.99992 3.5625ZM2.64992 9.5C4.02492 12.16 6.86659 13.8542 9.99992 13.8542C13.1333 13.8542 15.9749 12.16 17.3499 9.5C15.9749 6.84 13.1333 5.14583 9.99992 5.14583C6.86659 5.14583 4.02492 6.84 2.64992 9.5Z"
                          fill="#FFD500"
                        />
                      </svg>
                      &nbsp; {msj_ver_grupos}
                    </button>
                  </div>

                  <div className="d-flex justify-content-between va-middle course-info-1 mb-4">
                    <p className="  mb-0">
                      Total cursos habilitados: <span className="fw-medium">{calculoDeAignaturas("totalAsignatura")}</span>
                    </p>
                    <p className=" mb-0">
                      Total Obligatorios: <span className="fw-medium">{calculoDeAignaturas("O")}</span>
                    </p>
                    <p className=" mb-0">
                      Total Complementarios: <span className="fw-medium">{calculoDeAignaturas("C")}</span>
                    </p>
                    <p className=" mb-0">
                      Total Electivos: <span className="fw-medium">{calculoDeAignaturas("E")}</span>
                    </p>
                  </div>

                  {
                    mostrarListadoAsignatura &&
                    <div className="asignaturas">
                      {listadoAsignaturasFiltrar.map((data, index) => {
                        return (
                          <RowAsignatura
                            key={index}
                            id={data.scurso}
                            titulo={`${data.scurso} - ${data.dcurso}`}
                            estado={data.stipo}
                            nomTooltip={data.dtipo}
                            ciclo={data.cciclo}
                            vez={data.nveces}
                            creditos={data.ncredito}
                            binscrito={data.binscrito}
                          />
                        );
                      })}
                      <div className="d-flex justify-content-end gap-5 px-3"><p>Total  de créditos:</p> <strong className='col-sm-1'>{creditosTotales}</strong></div>
                    </div>
                  }
                </>
              }

              {
                mostrarAlerta && <div className="px-3">
                  <div className="alert alert-warning" role="alert">
                    <p className="mb-0" style={{ lineHeight: "1.2" }}>
                      <svg
                        style={{ width: 24, height: 24, marginRight: 5 }}
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="currentColor"
                          d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
                        />

                      </svg>
                      {alertaMensaje}
                    </p>
                  </div>
                </div>
              }


            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Asignaturas;
